export default __webpack_public_path__ + "static/media/therame.39e91541.svg";